import comp from "./ConfigureColumnsOverlay";
export default comp;
